import React, {useEffect} from 'react';
import logoImage from '@assets/images/logo.png';
import '@pages/Maintenance/maintenance.scss';

const Maintenance = () => {
  const handleFooter = (footer:any, main:any) => {
    if (footer && main) {
      let heightWillFix = window.innerHeight - 60 - footer.clientHeight;

      if (main.clientHeight < heightWillFix){
        footer.classList.add("fixed");
      } else {
        footer.classList.remove("fixed");
      }
    }
  }
  useEffect(() => {
    const footerEl = document.querySelector(".footer");
    const mainEl = document.querySelector("main");
    handleFooter(footerEl, mainEl);
    const bodyEl = document.querySelector("body");
    if(bodyEl) {
      bodyEl.classList.add("body-quaternary");
    }
    return () => {
      if(bodyEl) {
        bodyEl.classList.remove("body-quaternary");
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="maintenace-page">
      <header className="header">
        <div className="container">
          <div className="logo"><img src={logoImage} alt=""/></div>
        </div>
      </header>
      <main>
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 col-xl-6 col-xl-5">
              <h1 className="h1-title">Fibretrace is currently down for scheduled maintenance.</h1>
              <h3 className="h3-title">We expect to be back shortly. Thank you for your patience.</h3>
            </div>
          </div>
        </div>
      </main>
      <footer className='footer'>
        <div className="container">
          <div className="footer-bottom-left">
            © {(new Date()).getFullYear()} Fibretrace. All Rights Reserved
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Maintenance;
